import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatourpackge() {



    const cardData = {

keyword: "Pune to Ayodhya Tour Package",

headingDescription:
    "Rising Cab Service offers a comfortable and well-planned Pune to Ayodhya Tour Package for families, pilgrims, and spiritual travelers. We provide safe long-distance travel with Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs. Our package includes doorstep pickup from Pune, flexible one-way or round-trip options, 24/7 support, and transparent pricing. Whether you are visiting for Shri Ram Janmabhoomi darshan or exploring nearby spiritual sites, Rising Cab Service ensures a smooth and peaceful journey to Ayodhya.",

topPlaces: [
    {
        title: "Shri Ram Janmabhoomi Temple",
        description:
            "Shri Ram Janmabhoomi Temple is the most sacred site in Ayodhya, dedicated to Lord Ram. The grand temple complex showcases stunning architecture, deep spiritual significance, and attracts millions of devotees from across the world for darshan and devotion."
    },
    {
        title: "Hanuman Garhi",
        description:
            "Hanuman Garhi is one of the most important temples in Ayodhya dedicated to Lord Hanuman. Situated on a hilltop, it offers spiritual peace and panoramic views of the city, attracting devotees throughout the year."
    },
    {
        title: "Kanak Bhawan",
        description:
            "Kanak Bhawan is a beautiful temple dedicated to Lord Ram and Goddess Sita, known for its golden idols, intricate carvings, and serene atmosphere. It is one of the most visited temples in Ayodhya."
    },
    {
        title: "Saryu River Ghats",
        description:
            "The Saryu River Ghats are sacred bathing and prayer spots where devotees perform rituals and attend evening aarti. The peaceful environment and spiritual energy make it a must-visit place in Ayodhya."
    },
    {
        title: "Nageshwarnath Temple",
        description:
            "Nageshwarnath Temple is an ancient Shiva temple believed to have been established by Kush, the son of Lord Ram. It holds great religious importance and is a key pilgrimage site in Ayodhya."
    },
    {
        title: "Treta Ke Thakur",
        description:
            "Treta Ke Thakur Temple is believed to mark the site of ancient rituals performed during Lord Ram’s era. It is known for its historical significance and traditional architecture."
    },
    {
        title: "Guptar Ghat",
        description:
            "Guptar Ghat is a serene ghat on the banks of the Saryu River believed to be the place where Lord Ram took Jal Samadhi. It is a peaceful and spiritually significant location."
    },
    {
        title: "Ramkatha Park",
        description:
            "Ramkatha Park is a well-maintained cultural park used for religious events, Ramayana recitations, and large gatherings. It offers a peaceful environment for visitors and pilgrims."
    },
    {
        title: "Bharat Kund",
        description:
            "Bharat Kund is a sacred site associated with Lord Bharat, known for its historical and religious importance. It is surrounded by peaceful natural surroundings and temples."
    },
    {
        title: "Ayodhya Old City Streets",
        description:
            "The old streets of Ayodhya reflect the city's deep spiritual and cultural heritage. Visitors can explore traditional markets, temples, and experience the devotional atmosphere of this ancient city."
    }
],



services: [
{
name: "Pune to Ayodhya Tour Package",
description: "Rising Cab Service offers Pune to Ayodhya Tour Package for a comfortable and spiritual journey to the holy city of Lord Ram. Enjoy well-planned travel with AC Sedan, SUV, Innova Crysta, and Tempo Traveller options, professional drivers, doorstep pickup, and flexible itinerary for families, groups, and pilgrims."
},
{
name: "Pune to Ayodhya Cab Package",
description: "Book Pune to Ayodhya Cab Package with Rising Cab Service for a safe and convenient long-distance pilgrimage. We provide clean vehicles, experienced chauffeurs, transparent pricing, and flexible travel options for one way and round trip journeys."
},
{
name: "Pune to Ayodhya Taxi Service",
description: "Our Pune to Ayodhya Taxi Service ensures reliable intercity travel with well-maintained vehicles, professional drivers, and 24x7 booking support for a smooth and stress-free religious trip."
},
{
name: "Pune to Ayodhya Darshan Package",
description: "Rising Cab Service provides Pune to Ayodhya Darshan Package designed for devotees visiting Ram Mandir and other sacred sites. Enjoy comfortable travel, flexible stops, and complete pilgrimage support."
},
{
name: "Pune to Ayodhya Cab Booking",
description: "Book Pune to Ayodhya Cab Booking instantly with multiple vehicle choices, easy reservation, and 24x7 customer support for hassle-free spiritual travel planning."
},
{
name: "Pune to Ayodhya Ram Mandir Tour",
description: "Our Pune to Ayodhya Ram Mandir Tour offers a dedicated pilgrimage experience to Shri Ram Janmabhoomi with safe transportation, guided travel options, and comfortable AC vehicles for families and devotees."
},
{
name: "Pune to Ayodhya Pilgrimage Tour",
description: "Rising Cab Service offers Pune to Ayodhya Pilgrimage Tour with customized travel plans covering temples, spiritual sites, and comfortable long-distance cab service for devotees."
},
{
name: "Pune to Ayodhya One Way Cab",
description: "Book Pune to Ayodhya One Way Cab for affordable drop-only travel with flexible pickup options, AC vehicles, and professional drivers for long-distance journeys."
},
{
name: "Pune to Ayodhya Round Trip Cab",
description: "Our Pune to Ayodhya Round Trip Cab service is ideal for return journeys with comfortable waiting options, safe driving, and budget-friendly travel packages for families and groups."
},
{
name: "Pune to Ayodhya Family Tour Package",
description: "Rising Cab Service provides Pune to Ayodhya Family Tour Package with spacious vehicles, safe travel, and customized itineraries for a comfortable family pilgrimage experience."
},
{
name: "Pune to Ayodhya Innova Crysta Cab",
description: "Book Pune to Ayodhya Innova Crysta Cab for premium comfort, spacious seating, and smooth long-distance travel ideal for family and group pilgrimages."
},
{
name: "Pune to Ayodhya Outstation Cab",
description: "Our Pune to Ayodhya Outstation Cab service ensures safe and reliable long-distance travel with experienced drivers, AC vehicles, and flexible pickup and drop options."
},
{
name: "Pune to Ayodhya Religious Tour",
description: "Rising Cab Service offers Pune to Ayodhya Religious Tour for devotees seeking a peaceful and well-organized pilgrimage experience with comfortable transportation and flexible travel plans."
},
{
name: "Pune to Ayodhya AC Cab Booking",
description: "Book Pune to Ayodhya AC Cab Booking for comfortable travel in all weather conditions with clean air-conditioned vehicles and professional chauffeurs."
},
{
name: "Pune to Ayodhya Tour by Car",
description: "Our Pune to Ayodhya Tour by Car provides personalized travel experience with private cab service, flexible stops, and comfortable long-distance journey options."
},
{
name: "Pune to Ayodhya Ram Lalla Darshan Package",
description: "Rising Cab Service offers Pune to Ayodhya Ram Lalla Darshan Package with dedicated travel to Ram Mandir, guided pilgrimage support, and comfortable transportation for devotees."
},
{
name: "Ayodhya Tour Package from Pune",
description: "Book Ayodhya Tour Package from Pune with complete travel solutions including cab service, sightseeing assistance, and customized pilgrimage itineraries."
},
{
name: "Pune to Ayodhya Spiritual Tour",
description: "Our Pune to Ayodhya Spiritual Tour provides a peaceful and comfortable journey to sacred destinations with professional drivers and well-maintained vehicles."
},
{
name: "Pune to Ayodhya Pilgrimage Cab",
description: "Rising Cab Service offers Pune to Ayodhya Pilgrimage Cab for safe and comfortable religious travel with flexible schedules and affordable pricing."
},
{
name: "Pune to Ayodhya Holiday Package",
description: "Book Pune to Ayodhya Holiday Package for a blend of spiritual and leisure travel with comfortable cab service and customized tour planning."
},
{
name: "Pune to Ayodhya Luxury Cab Package",
description: "Our Pune to Ayodhya Luxury Cab Package offers premium vehicles like Innova Crysta and SUV for a comfortable, safe, and elegant long-distance pilgrimage journey."
}
],

tableData: [
["Pune to Ayodhya Tour Package","Pune to Ayodhya Cab Package"],
["Pune to Ayodhya Tour","Pune to Ayodhya Taxi Service"],
["Pune to Ayodhya Darshan Package","Pune to Ayodhya Cab Booking"],
["Pune to Ayodhya Ram Mandir Tour","Pune to Ayodhya Pilgrimage Tour"],
["Pune to Ayodhya One Way Cab","Pune to Ayodhya Round Trip Cab"],
["Pune to Ayodhya Family Tour Package","Pune to Ayodhya Innova Crysta Cab"],
["Pune to Ayodhya Outstation Cab","Pune to Ayodhya Religious Tour"],
["Pune to Ayodhya AC Cab Booking","Pune to Ayodhya Tour by Car"],
["Ayodhya Tour Package from Pune","Pune to Ayodhya Ram Lalla Darshan Package"],
["Pune to Ayodhya Spiritual Tour","Pune to Ayodhya Pilgrimage Cab"],
["Pune to Ayodhya Holiday Package","Pune to Ayodhya Luxury Cab Package"]
],



whychoose: [
    {
        WhyChooseheading: "Complete Pune to Ayodhya Tour Packages",
        WhyChoosedescription: "Rising Cab Service offers well-planned Pune to Ayodhya tour packages for families, devotees, senior citizens, religious groups, and spiritual travelers."
    },
    {
        WhyChooseheading: "Comfortable Ram Mandir Darshan Journey",
        WhyChoosedescription: "Travel conveniently to the sacred city of Ayodhya and experience the divine Shri Ram Janmabhoomi Mandir with hassle-free transportation arrangements."
    },
    {
        WhyChooseheading: "Customized Pilgrimage Travel Plans",
        WhyChoosedescription: "Customers can choose one-way tours, round-trip packages, multi-day religious journeys, and personalized pilgrimage itineraries according to their schedule."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles suitable for individual travelers, families, and larger groups."
    },
    {
        WhyChooseheading: "Cover Major Religious Attractions",
        WhyChoosedescription: "Tour packages can include Shri Ram Janmabhoomi, Hanuman Garhi, Kanak Bhawan, Saryu Ghat, Nageshwarnath Temple, and other sacred places in Ayodhya."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Ideal for Family and Group Pilgrimages",
        WhyChoosedescription: "Our Ayodhya tour packages are suitable for family tours, senior citizen groups, religious organizations, and spiritual gatherings."
    },
    {
        WhyChooseheading: "Safe and Comfortable Long-Distance Travel",
        WhyChoosedescription: "Experienced drivers, well-maintained vehicles, and professional trip planning ensure a peaceful and enjoyable pilgrimage experience."
    }
]
};

const faqData = [
    {
        question: "Why is Ayodhya one of the most important pilgrimage destinations in India?",
        answer: "Ayodhya is believed to be the birthplace of Lord Shri Ram and is home to the revered Shri Ram Janmabhoomi Mandir."
    },
    {
        question: "Which places are included in a Pune to Ayodhya tour package?",
        answer: "Popular attractions include Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Kanak Bhawan, Saryu River Ghat, Nageshwarnath Temple, and other religious sites."
    },
    {
        question: "Can families book private vehicles for the Ayodhya tour?",
        answer: "Yes, private vehicles including Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are available."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for religious groups, family tours, and senior citizen travel."
    },
    {
        question: "Can the itinerary be customized according to our requirements?",
        answer: "Yes, customers can customize travel duration, sightseeing locations, stopovers, and accommodation preferences."
    },
    {
        question: "Is the package suitable for senior citizens?",
        answer: "Yes, many senior citizens prefer private cab tours because of the flexibility, comfort, and convenience they provide."
    },
    {
        question: "Can nearby religious destinations be included in the tour?",
        answer: "Yes, customized packages can include Prayagraj, Varanasi, Chitrakoot, Naimisharanya, and other pilgrimage destinations."
    },
    {
        question: "Are multi-day Ayodhya tour packages available?",
        answer: "Yes, customers can choose multi-day pilgrimage packages based on their travel plans and sightseeing requirements."
    },
    {
        question: "Can the journey start from Pune Airport or Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Ayodhya Tour Package?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Shriram Joshi",
        feedback:
            "Visiting Ayodhya and Shri Ram Mandir was a dream come true for our family. Rising Cab Service handled the entire journey professionally and made the pilgrimage truly memorable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Madhuri Kulkarni",
        feedback:
            "Our religious tour to Ayodhya was planned perfectly. The vehicle was comfortable, the itinerary was well organized, and every part of the journey was smooth and peaceful.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ayodhya Tour Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ayodhya-cab.jpg",
"description": "Book Pune to Ayodhya Tour Package with Rising Cab Service for a safe and comfortable pilgrimage to Ram Mandir. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova Crysta for family and religious tours.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ayodhya-tour-package"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Ayodhya Tour Package | Ram Mandir Cab Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ayodhya Tour Package for a safe and comfortable pilgrimage to Ram Mandir. Get reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova Crysta for family tours."
/>

<meta
 name="keywords"
 content="Pune to Ayodhya Tour Package, Pune to Ayodhya Cab Package, Pune to Ayodhya Tour, Pune to Ayodhya Taxi Service, Pune to Ayodhya Darshan Package, Pune to Ayodhya Cab Booking, Pune to Ayodhya Ram Mandir Tour, Pune to Ayodhya Pilgrimage Tour, Pune to Ayodhya One Way Cab, Pune to Ayodhya Round Trip Cab, Pune to Ayodhya Family Tour Package, Pune to Ayodhya Innova Crysta Cab, Pune to Ayodhya Outstation Cab, Pune to Ayodhya Religious Tour"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoayodhyatourpackge;